<template>
  <div class="offers-view">
    <h1>{{ $t('routes.offers') }}</h1>
    <div class="category" v-for="({ name: categoryName, size, offers: categoryOffers }) in categories" :key="`category.${categoryName}`">
      <h2>{{ $t(`categories.${categoryName}`) }}</h2>
      <div class="offer-row">
        <Offer v-for="({ id, name: offerName, imageUrl }) in categoryOffers" :key="`offer.${id}`" :name="offerName" :imageUrl="imageUrl" :size="size" />
      </div>
    </div>
    <div class="soon">
      <div class="soon-text">{{ $t('soon') }}</div>
    </div>
  </div>
</template>

<i18n>
  {
    "es": {
      "soon": "Próximamente...",
      "categories": {
        "product": "Productos",
        "service": "Servicios",
        "donation": "Donaciones"
      }
    },
    "en": {
      "soon": "Soon...",
      "categories": {
        "product": "Products",
        "service": "Services",
        "donation": "Donations"
      }
    }
  }
</i18n>

<script>
  import groupBy from 'lodash.groupby';
  import Offer from '@/components/Offer.vue';

  export default {
    name: 'offers-view',
    components: {
      Offer,
    },
    data() {
      return {
        offers: [
          {
            id: '112bee69-ced6-4c7c-99a9-336246aa94c4',
            category: 'product',
            name: 'Axe Excite',
            imageUrl: 'https://www.axe.com/content/dam/unilever/axe/mexico/pack_shot/new_67543970_awv04_ball_can_deos_axe_excite_bs_150ml_mex-1573944-png.png',
          },
          {
            id: 'ba5c541e-6364-4c71-8306-83c228abefc3',
            category: 'product',
            name: 'Dove Original',
            imageUrl: 'https://www.dove.com/content/dam/unilever/dove/united_kingdom/pack_shot/front/deodorants_and_fragrances/deodorants/dove_original_roll-on_anti-perspirant_deodorant_50ml/dove_original_anti-perspirant_deodorant_roll_on-1128300-png.png',
          },
          {
            id: 'bebebea0-773d-4810-bfce-0f28db73a7cc',
            category: 'product',
            name: "HELLMANN's Clásica",
            imageUrl: 'https://www.hellmanns.com/content/dam/unilever/hellmann_s_world/saint_kitts_and_nevis/pack_shot/front/all/all/hellmann_s_mayonesa_sin_tacc_332_gr-1200425.png',
          },
          {
            id: 'cdabdf98-4ad1-4eaf-88ef-72922011c863',
            category: 'product',
            name: 'Caldo de Gallina',
            imageUrl: 'https://www.knorr.com/content/dam/unilever/knorr_world/global/other_foods/all/caldo-cubo-de-gallina-x6-866608.png.ulenscale.315x315.png',
          },
          {
            id: '55ce29dc-14e9-4182-8bf1-b8e279eff253',
            category: 'product',
            name: 'ala Clásico',
            imageUrl: 'https://www.alcorrientes.com.ar/sitio//public_html/img/productos/jabones/01553-01.png',
          },
          {
            id: 'a772110b-8265-406d-91a2-bab4194b7ee2',
            category: 'product',
            name: 'Cif Antigrasa',
            imageUrl: 'https://www.cif.com.ar/content/dam/unilever/cif/argentina/pack_shot/7791290010277-1370370-png.png',
          },
          {
            id: '0a6fe7f0-40a9-4222-a10e-47ed95c1d3b1',
            category: 'service',
            name: 'Colocación de Durlock',
            imageUrl: 'https://www.durlock.com/uploads/documents/bb562815e4539567c75696315158969afb4047e9.jpeg',
          },
          {
            id: '66e4a6e1-8958-40d2-a22a-50678f2d7285',
            category: 'service',
            name: 'Clase de inglés',
            imageUrl: 'https://blog.britishcouncil.org.mx/hs-fs/hubfs/Maestra%20escribe%20en%20un%20pizarr%C3%B3n.jpg',
          },
          {
            id: '6adcd713-b04d-4682-8389-a2cdae3e10d9',
            category: 'service',
            name: 'Masaje',
            imageUrl: 'https://amasajes.com/wp-content/uploads/2019/01/masaje-relajante.jpg',
          },
          {
            id: '912341f7-73b0-45c3-b18c-90243b2e07cb',
            category: 'service',
            name: 'Limpieza',
            imageUrl: 'https://www.residenciasarria.com/blog/wp-content/uploads/2016/10/productos-limpieza.jpg',
          },
          {
            id: '9598afac-7724-4add-aa3f-fb4ec6e47ed0',
            category: 'donation',
            name: 'Green Peace',
            imageUrl: 'https://enladiversidadblog.files.wordpress.com/2018/03/greenpeace-logo.png',
          },
          {
            id: '34da5d7f-9ab5-477c-bc05-574bd4dff282',
            category: 'donation',
            name: 'Fundación Garrahan',
            imageUrl: 'https://http2.mlstatic.com/storage/mshops-appearance-api/images/32/201072632/logo-2019092821061602800.png',
          },
          {
            id: '6c6d9833-ed90-49d1-ba93-6d8a23ffad99',
            category: 'donation',
            name: 'TECHO',
            imageUrl: 'https://www.techo.org/wp-content/uploads/2019/04/Color-RGB-Sin-fondo-02.png',
          },
        ],
      };
    },
    computed: {
      categories() {
        const groupedItems = groupBy(this.offers, 'category');
        const categories = Object.keys(groupedItems).map((categoryName) => {
          const temporarySizes = {
            product: 'small',
            service: 'large',
            donation: 'medium',
          };
          return {
            name: categoryName,
            // size: ['small', 'medium', 'large'][Math.floor(Math.random() * 3)],
            size: temporarySizes[categoryName],
            offers: groupedItems[categoryName],
          };
        });
        return categories;
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '@/assets/styles/mixins.scss';

  .offers-view {
    padding: 1em;
    display: flex;
    flex-direction: column;
  }

  .offer-row {
    padding: 1em;
    display: flex;
    overflow: visible;
    overflow-x: scroll;
    @include separate-children('horizontal');
  }

  .soon {
    position: absolute;
    z-index: 10;
    inset: 0;

    background-color: rgba(0, 0, 0, 0.7);

    display: flex;
    justify-content: center;
    align-items: center;
  }

  .soon-text {
    font-size: 3.5em;
    color: white;
    transform: rotateZ(-45deg);
  }
</style>
